module.exports = __webpack_public_path__ + "img/wilderness.291a8a3.png";